import IterationPageHeader from 'components/IterationPageHeader';
import ProgressIndicator from 'components/ProgressIndicator';
import ReportList from 'components/SummaryReport/ReportList';
import SummaryReportActions from 'components/SummaryReportsActions';
import { Breadcrumb } from 'nhsuk-react-components';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import useFetchSummaryReport from 'queries/fetch/fetchSummaryReport.ts';
import { Navigate, useParams } from 'react-router-dom';
import { SummaryReport } from 'schemas/SummaryReport.schema.ts';
import { getIterationById } from 'utils/iterationUtils.ts';

function SummaryReportsPage() {
  const { teamId, campaignId, iterationId } = useParams();
  const fetchSpecificCampaign = useFetchSpecificCampaign({
    teamId: teamId!,
    campaignId: campaignId!,
  });
  const fetchSummaryReports = useFetchSummaryReport({
    teamId: teamId!,
    campaignId: campaignId!,
    iterationId: iterationId!,
  });

  if (
    !fetchSummaryReports.data
    || !fetchSpecificCampaign.data
    || fetchSummaryReports.status !== 'success'
    || fetchSpecificCampaign.status !== 'success'
  ) {
    return <ProgressIndicator text="Loading summary reports..." />;
  }

  if (fetchSummaryReports.data.length === 0) {
    return <Navigate to={`/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary`} replace />;
  }

  const currentIteration = getIterationById(
    fetchSpecificCampaign.data!,
    iterationId!,
  );

  return (
    <>
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/campaigns">
            Manage campaigns
          </Breadcrumb.Item>
          <Breadcrumb.Item href={`/${teamId}/campaign/${campaignId}/summary`}>
            Campaign summary
          </Breadcrumb.Item>
          <Breadcrumb.Item href={`/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary`}>
            Iteration summary
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Summary reports</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <IterationPageHeader
        title="Summary reports"
        iteration={currentIteration!}
      />
      <ReportList
        reports={fetchSummaryReports.data as SummaryReport[]}
        iteration={currentIteration!}
        campaign={fetchSpecificCampaign.data!}
      />
      <SummaryReportActions
        teamId={teamId!}
        campaignId={campaignId!}
        iterationId={iterationId!}
      />
    </>
  );
}

export default SummaryReportsPage;
